import { Currency } from '@/core/currency/interfaces';

const PGK: Currency = {
    name: 'Papua New Guinean Kina',
    demonym: 'Papua New Guinean',
    majorSingle: 'Kina',
    majorPlural: 'Kina',
    codeNumeric: '598',
    symbol: 'K',
    symbolNative: 'K',
    minorSingle: 'Toea',
    minorPlural: 'Toea',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'PGK',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default PGK;
